import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-544f0348"),n=n(),_popScopeId(),n)
const _hoisted_1 = { className: "carousel" }
const _hoisted_2 = { className: "carousel-outer" }
const _hoisted_3 = { className: "carousel-inner" }
const _hoisted_4 = { className: "carousel-box carousel-border1" }
const _hoisted_5 = { className: "box_content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { className: "carousel-title" }, "パーティー", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/design/service_0.png",
  alt: "パーティ"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 男女複数名で参加する")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("いわゆる合コンです ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/design/search.png",
  alt: "search"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" パーティー毎に参加条件が異なります。 ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 【パーティーの流れ】 ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, " パーティーの一覧より条件をご確認のうえお申し込みください。 "),
  /*#__PURE__*/_createElementVNode("li", null, " リアル開催の場合は会場を、オンラインの場合はZoomでの参加方法をご案内します。 "),
  /*#__PURE__*/_createElementVNode("li", null, "パーティーを開催、後日会費お支払い")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { className: "merit" }, "メリット"),
  /*#__PURE__*/_createTextVNode(" 気負わずに参加できる、同性異性の友達ができる"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { className: "demerit" }, "デメリット"),
  /*#__PURE__*/_createTextVNode(" 自分の条件に合う人が来るとは限らない（むしろ相性が良いこともありうる）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" →パーティーとお見合いの併用療法を推奨します ")
], -1))
const _hoisted_22 = { className: "carousel-box carousel-border2" }
const _hoisted_23 = { className: "box_content" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { className: "carousel-title" }, "お見合い", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/design/service_1.png",
  alt: "お見合い"
}, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 男女一名ずつがオンライン")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode("またはリアルの対面 ")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/design/search.png",
  alt: "search"
}, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 男女の都合の合うタイミングで随時開催、年齢制限なし。")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode("会費：15,000円（オンライン）、20,000円（リアルの対面：東京、大阪、福岡、名古屋、沖縄） ")
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode("※申し込みは無料、お見合い成立時にのみ料金発生")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 【お見合いの流れ】 ")
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" 女医コンサイトに未登録の場合、"),
    /*#__PURE__*/_createElementVNode("a", { href: "/requests/sign_up" }, " こちら "),
    /*#__PURE__*/_createTextVNode("から情報を登録 ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" 女性が"),
    /*#__PURE__*/_createElementVNode("a", { href: "/matchmaking/onboarding" }, " 男性プロフィール検索 "),
    /*#__PURE__*/_createTextVNode("またはメール配信を通じて男性のプロフィールを閲覧"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("（希望があれば女性から男性にプロフィールを配信することも可能） ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, " 会ってみたい場合、女性が男性にお見合いリクエストを送る "),
  /*#__PURE__*/_createElementVNode("li", null, "リクエストを受けた男性は女性のプロフィールを閲覧する"),
  /*#__PURE__*/_createElementVNode("li", null, "男性もお見合い希望であれば、スケジュールを設定"),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" お見合いを実施、前日までに会費をお支払い"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("（お支払い先はメールにてご連絡いたします） ")
  ])
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { className: "merit" }, "メリット"),
  /*#__PURE__*/_createTextVNode(" お互いに相手のプロフィールを見てから選べる ")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { className: "demerit" }, "デメリット"),
  /*#__PURE__*/_createTextVNode(" 選びはするものの選ばれる確率が低く、お見合いリクエストだけで終わることが多い"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" →パーティーとお見合いの併用療法を推奨します ")
], -1))
const _hoisted_45 = { className: "carousel-box carousel-border3" }
const _hoisted_46 = { className: "box_content" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { className: "carousel-title" }, "月額有料会員", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/design/service_2.png",
  alt: "月額有料会員"
}, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { className: "" }, [
  /*#__PURE__*/_createTextVNode(" パーティーやお見合いを"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("効率的にする追加支援 ")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/design/search.png",
  alt: "search"
}, null, -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" パーティーやお見合いを、より強力にサポートします。 運用作業やSMSブロードキャスト費用を要するため、料金を戴いています。")
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_55 = /*#__PURE__*/_createTextVNode("会費：3,000円（月額）")
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" 【月額有料会員登録の流れ】 ")
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" 女医コンサイトに未登録の場合、"),
    /*#__PURE__*/_createElementVNode("a", { href: "/requests/sign_up" }, " こちら "),
    /*#__PURE__*/_createTextVNode("から情報を登録 ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" 女医コンサイトに登録後、"),
    /*#__PURE__*/_createElementVNode("a", { href: "/membership/new" }, " こちら "),
    /*#__PURE__*/_createTextVNode("からサポート内容の確認と月額有料会員の登録ができます。 ")
  ])
], -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { className: "merit" }, "メリット"),
  /*#__PURE__*/_createTextVNode(" より多くの人にアプローチできる ")
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { className: "demerit" }, "デメリット"),
  /*#__PURE__*/_createTextVNode(" 有料 ")
], -1))
const _hoisted_63 = { className: "carousel-overlay" }
const _hoisted_64 = { className: "carousel-overlay-inner" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { className: "p-carousel-prev-icon pi pi-chevron-left" }, null, -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { className: "p-carousel-next-icon pi pi-chevron-right" }, null, -1))
const _hoisted_68 = [
  _hoisted_67
]

import { ref, onMounted } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  path: String,
  model: Object,
  user: Object,
  args: String,
},
  setup(__props) {

const props = __props

const areaRef = ref(null);
const leftRef = ref(null);
const rightRef = ref(null);



function getScrollbarWidth() {
  let element = document.createElement("div");
  element.style.visibility = "hidden";
  element.style.overflow = "scroll";
  document.body.appendChild(element);
  const scrollbarWidth = element.offsetWidth - element.clientWidth;
  document.body.removeChild(element);
  return scrollbarWidth;
}

const fixBody = function () {
  let diff = getScrollbarWidth();
  if (diff > 0) {
    document.body.style["padding-right"] = diff + "px";
    document.body.classList.add("service-overflow-hidden");
  }
};

const releaseBody = function () {
  document.body.style["padding-right"] = "0px";
  document.body.classList.remove("service-overflow-hidden");
};

const displayModal_0 = ref(false);
const openModal_0 = () => {
  displayModal_0.value = true;
};
const closeModal_0 = () => {
  displayModal_0.value = false;
};

const displayModal_1 = ref(false);
const openModal_1 = () => {
  displayModal_1.value = true;
};
const closeModal_1 = () => {
  displayModal_1.value = false;
};

const displayModal_2 = ref(false);
const openModal_2 = () => {
  displayModal_2.value = true;
};
const closeModal_2 = () => {
  displayModal_2.value = false;
};

const move_left = function () {
  let moveAvailable = areaRef.value.scrollWidth - areaRef.value.clientWidth;
  let moveCount = areaRef.value.clientWidth > 294 * 2 + 4 ? 1 : 2;
  let moveValue = moveAvailable / moveCount;
  let val = Math.floor((areaRef.value.scrollLeft - 1) / moveValue);
  let leftValue = moveValue * val;
  updateLeft(moveAvailable, areaRef.value.scrollLeft);
  updateRight(moveAvailable, areaRef.value.scrollLeft);

  areaRef.value.scrollTo({
    left: leftValue,
    behavior: "smooth",
  });
};
const move_right = function () {
  let moveAvailable = areaRef.value.scrollWidth - areaRef.value.clientWidth;
  let moveCount = areaRef.value.clientWidth > 294 * 2 + 4 ? 1 : 2;
  let moveValue = moveAvailable / moveCount;
  let val = Math.floor((areaRef.value.scrollLeft + 1) / moveValue);
  let leftValue = moveValue * (val + 1);

  updateLeft(moveAvailable, areaRef.value.scrollLeft);
  updateRight(moveAvailable, areaRef.value.scrollLeft);

  areaRef.value.scrollTo({
    left: leftValue,
    behavior: "smooth",
  });
};

const updateLeft = (area, pos) => {
  if (area > 0 && pos > 5) {
    leftRef.value.style.display = "flex";
  } else {
    leftRef.value.style.display = "none";
  }
};
const updateRight = (area, pos) => {
  if (area > 0 && pos < area - 5) {
    rightRef.value.style.display = "flex";
  } else {
    rightRef.value.style.display = "none";
  }
};

const calculateWindowWidth = () => {
  let moveAvailable = areaRef.value.scrollWidth - areaRef.value.clientWidth;
  updateLeft(moveAvailable, areaRef.value.scrollLeft);
  updateRight(moveAvailable, areaRef.value.scrollLeft);
};

onMounted(() => {
  window.addEventListener("resize", calculateWindowWidth);
  areaRef.value.addEventListener("scroll", calculateWindowWidth);
  leftRef.value.style.display = "none";
});

return (_ctx: any,_cache: any) => {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "areaRef",
      ref: areaRef,
      className: "carousel-area"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("div", {
                className: "show_all icon",
                onClick: openModal_0
              }, _hoisted_12),
              _createVNode(_component_Dialog, {
                header: "パーティー",
                visible: displayModal_0.value,
                "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((displayModal_0).value = $event)),
                style: {},
                modal: true,
                className: "service_dialog",
                onShow: fixBody,
                onHide: releaseBody
              }, {
                footer: _withCtx(() => []),
                default: _withCtx(() => [
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _hoisted_21
                ]),
                _: 1
              }, 8, ["visible"])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _hoisted_25,
              _hoisted_26,
              _hoisted_27,
              _hoisted_28,
              _createElementVNode("div", {
                className: "show_all icon",
                onClick: openModal_1
              }, _hoisted_30),
              _createVNode(_component_Dialog, {
                header: "お見合い",
                visible: displayModal_1.value,
                "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((displayModal_1).value = $event)),
                style: {},
                modal: true,
                className: "service_dialog",
                onShow: fixBody,
                onHide: releaseBody
              }, {
                footer: _withCtx(() => []),
                default: _withCtx(() => [
                  _hoisted_31,
                  _hoisted_32,
                  _hoisted_33,
                  _hoisted_34,
                  _hoisted_35,
                  _hoisted_36,
                  _hoisted_37,
                  _hoisted_38,
                  _hoisted_39,
                  _hoisted_40,
                  _hoisted_41,
                  _hoisted_42,
                  _hoisted_43,
                  _hoisted_44
                ]),
                _: 1
              }, 8, ["visible"])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _hoisted_48,
              _hoisted_49,
              _createElementVNode("div", {
                className: "show_all icon",
                onClick: openModal_2
              }, _hoisted_51),
              _createVNode(_component_Dialog, {
                header: "月額有料会員",
                visible: displayModal_2.value,
                "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((displayModal_2).value = $event)),
                style: {},
                modal: true,
                className: "service_dialog",
                onShow: fixBody,
                onHide: releaseBody
              }, {
                footer: _withCtx(() => []),
                default: _withCtx(() => [
                  _hoisted_52,
                  _hoisted_53,
                  _hoisted_54,
                  _hoisted_55,
                  _hoisted_56,
                  _hoisted_57,
                  _hoisted_58,
                  _hoisted_59,
                  _hoisted_60,
                  _hoisted_61,
                  _hoisted_62
                ]),
                _: 1
              }, 8, ["visible"])
            ])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_63, [
      _createElementVNode("div", _hoisted_64, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            ref_key: "leftRef",
            ref: leftRef,
            className: "p-carousel-prev p-link",
            type: "button",
            onClick: move_left
          }, _hoisted_66, 512)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            ref_key: "rightRef",
            ref: rightRef,
            className: "p-carousel-next p-link",
            type: "button",
            onClick: move_right
          }, _hoisted_68, 512)
        ])
      ])
    ])
  ]))
}
}

})